// extracted by mini-css-extract-plugin
export var address = "Address-module--address--518e3";
export var contact = "Address-module--contact--68d49";
export var flexSection = "Address-module--flex-section--d22a5";
export var logo = "Address-module--logo--3e0b4";
export var orange = "Address-module--orange--3f038";
export var tel = "Address-module--tel--217e4";
export var thin = "Address-module--thin--6d69a";